<template>
    <paper class="ssm-idle-resource">
        <div class="type-radio-group">
            <span class="label">分类</span>
            <el-radio-group v-model="currentType">
                <el-radio-button
                    v-for="item in TYPE_LIST"
                    :key="item.value"
                    :label="item.value"
                    :disabled="item.disabled">
                    {{ item.label }}
                </el-radio-button>
            </el-radio-group>
        </div>
        <LoadUnloadPane v-if="currentType === TYPE_LIST[0].value" />
        <WarehousePane v-else-if="currentType === TYPE_LIST[1].value" />
        <DevicePane v-else-if="currentType === TYPE_LIST[2].value" />
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/supplierPanel';
import LoadUnloadPane from './LoadUnloadPane.vue';
import WarehousePane from './WarehousePane.vue';
import DevicePane from './DevicePane.vue';

const TYPE_LIST = [
    { value: 'loadUnload', label: '装卸' },
    { value: 'warehouse', label: '仓库' },
    { value: 'device', label: '设备类' },
]

export default {
    components: { paper, mPane, LoadUnloadPane, WarehousePane, DevicePane },
    data() {
        return {
            TYPE_LIST,
            currentType: TYPE_LIST[0].value,
        };
    },
};
</script>
<style lang="less">
.ssm-idle-resource {
    #mPane3 .el-table {
        min-height: calc(100vh - 244px);
        max-height: calc(100vh - 244px);
    }

    .type-radio-group {
        margin-bottom: 10px;

        .label {
            font-size: 12px;
            margin-right: 10px;
            vertical-align: middle;
        }
    }
}
</style>
